const BSItems = [
    { label: "流動資産合計", key: "TCA", "level": 0 },
    { label: "当座資産", key: "TCA_CA", "level": 1 },
    { label: "現金・預金", key: "TCA_CA_CaD", "level": 2 },
    { label: "受取手形", key: "TCA_CA_AR", "level": 2 },
    { label: "売掛金・工事未収入金", key: "TCA_CA_ARaCWUP", "level": 2 },
    { label: "有価証券", key: "TCA_CA_S", "level": 2 },
    { label: "棚卸資産", key: "TCA_I", "level": 1 },
    { label: "商品・製品", key: "TCA_I_S", "level": 2 },
    { label: "半製品・仕掛品", key: "TCA_I_WIP", "level": 2 },
    { label: "原材料・貯蔵品", key: "TCA_I_RMS", "level": 2 },
    { label: "未成工事支出金", key: "TCA_I_CIPE", "level": 2 },
    { label: "その他流動資産", key: "TCA_OCA", "level": 1 },
    { label: "前渡金", key: "TCA_OCA_AP", "level": 2 },
    { label: "前払費用・未収収益", key: "TCA_OCA_PEAI", "level": 2 },
    { label: "その他", key: "TCA_OCA_O", "level": 2 },
    { label: "貸倒引当金", key: "TCA_AfDA", "level": 1 },
    { label: "固定資産合計", key: "TFA", "level": 0 },
    { label: "有形固定資産", key: "TFA_TFA", "level": 1 },
    { label: "建物・構築物", key: "TFA_TFA_BaS", "level": 2 },
    { label: "機械装置", key: "TFA_TFA_ME", "level": 2 },
    { label: "車輌運搬具", key: "TFA_TFA_VTE", "level": 2 },
    { label: "工具器具備品", key: "TFA_TFA_TES", "level": 2 },
    { label: "土地", key: "TFA_TFA_L", "level": 2 },
    { label: "建設仮勘定", key: "TFA_TFA_CiP", "level": 2 },
    { label: "無形固定資産", key: "TFA_IFA", "level": 1 },
    { label: "投資その他の資産", key: "TFA_IaOA", "level": 1 },
    { label: "投資有価証券", key: "TFA_IaOA_IS", "level": 2 },
    { label: "その他", key: "TFA_IaOA_O", "level": 2 },
    { label: "繰延資産合計", key: "TDA", "level": 0 },
    { label: "資産合計", key: "TA", "level": 0 },
    { label: "負債合計", key: "TL", "level": 0 },
    { label: "流動負債合計", key: "TL_TCL", "level": 1 },
    { label: "支払手形", key: "TL_TCL_BP", "level": 2 },
    { label: "買掛金・工事未払金", key: "TL_TCL_APUC", "level": 2 },
    { label: "短期借入金", key: "TL_TCL_STB", "level": 2 },
    { label: "前受金・未成工事受入金", key: "TL_TCL_APaUCP", "level": 2 },
    { label: "未払費用・前受収益", key: "TL_TCL_AEaUR", "level": 2 },
    { label: "賞与引当金", key: "TL_TCL_BR", "level": 2 },
    { label: "未払法人税", key: "TL_TCL_UCT", "level": 2 },
    { label: "その他流動負債", key: "TL_TCL_OCL", "level": 2 },
    { label: "固定負債合計", key: "TL_TFL", "level": 1 },
    { label: "社債", key: "TL_TFL_CB", "level": 2 },
    { label: "長期借入金", key: "TL_TFL_LTD", "level": 2 },
    { label: "退職給付引当金", key: "TL_TFL_ARB", "level": 2 },
    { label: "その他固定負債", key: "TL_TFL_OFL", "level": 2 },
    { label: "純資産合計", key: "TNA", "level": 0 },
    { label: "株主資本", key: "TNA_SE", "level": 1 },
    { label: "資本金", key: "TNA_SE_C", "level": 2 },
    { label: "資本剰余金", key: "TNA_SE_CS", "level": 2 },
    { label: "利益剰余金", key: "TNA_SE_RE", "level": 2 },
    { label: "自己株式(△)", key: "TNA_SE_TS", "level": 2 },
    { label: "評価・換算差額等", key: "TNA_VaCD", "level": 1 },
    { label: "その他有価証券評価差額金", key: "TNA_VaCD_UGoOS", "level": 2 },
    { label: "繰延ヘッジ損益", key: "TNA_VaCD_DGaLoH", "level": 2 },
    { label: "土地再評価差額金", key: "TNA_VaCD_LRD", "level": 2 },
    { label: "新株予約権", key: "TNA_SAR", "level": 1 },
    { label: "負債・純資産合計", key: "TLaNA", "level": 0 },
    { label: "割引手形", key: "DA", "level": 0 },
    { label: "裏書譲渡手形", key: "ETB", "level": 0 },
    { label: "減価償却実施額", key: "DeA", "level": 0 },
    { label: "期末従業員数", key: "NoE", "level": 0 },
];

const PLItems = [
    { label: "売上高", key: "S", "level": 0 },
    { label: "売上原価", key: "CoS", "level": 0 },
    { label: "売上総利益", key: "GP", "level": 0 },
    { label: "販売費及び一般管理費", key: "SGaAE", "level": 0 },
    { label: "営業利益", key: "OP", "level": 0 },
    { label: "営業外収益", key: "TnOI", "level": 0 },
    { label: "受取利息・配当金", key: "TnOI_IaDA", "level": 1 },
    { label: "その他営業外収益", key: "TnOI_OnOI", "level": 1 },
    { label: "営業外費用", key: "TnOE", "level": 0 },
    { label: "支払利息・手形売却損", key: "TnOE_IaDA", "level": 1 },
    { label: "その他営業外費用", key: "TnOE_OnOI", "level": 1 },
    { label: "経常利益", key: "OrP", "level": 0 },
    { label: "特別利益", key: "SP", "level": 0 },
    { label: "特別損失", key: "EL", "level": 0 },
    { label: "税引前当期純利益", key: "PP", "level": 0 },
    { label: "法人税等充当額", key: "APfCT", "level": 0 },
    { label: "当期純利益", key: "NI", "level": 0 },
];

const IndustryTypeMap = {
    '製造業・一次産業': ['A', 'B', 'C', 'E'],
    '建設業': ['D'],
    '販売業・運輸業・サービス業': ['F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T']
}

const AnalysisResultMap: { [key: string]: any } = {
    '製造業・一次産業': [
        { key: 'NoTC', column: '集計企業数', type: 0 },
        { key: 'ANoE', column: '平均従業員数', type: 0 },
        { key: 'DR', column: '負債比率（％）', type: 2 },
        { key: 'ER', column: '自己資本比率（％）', type: 1 },
        { key: 'CR', column: '流動比率（％）', type: 1 },
        { key: 'QR', column: '当座比率（％）', type: 1 },
        { key: 'FAtER', column: '固定比率（％）', type: 2 },
        { key: 'FAtLTCR', column: '固定長期適合率（％）', type: 2 },
        { key: 'IBDR', column: '有利子負債構成比率（％）', type: 2 },
        { key: 'ARtAPR', column: '受取債権対支払債務比率（％）', type: 1 },
        { key: 'CATR', column: '流動資産回転率（回）', type: 1 },
        { key: 'CATD', column: '流動資産回転日数（日）', type: 2 },
        { key: 'ARTR', column: '受取債権回転率（回）', type: 1 },
        { key: 'ARTD', column: '受取債権回転日数（日）', type: 2 },
        { key: 'ITR', column: '棚卸資産回転率（回）', type: 1 },
        { key: 'ITD', column: '棚卸資産回転日数（日）', type: 2 },
        { key: 'STR', column: '商品・製品回転率（回）', type: 1 },
        { key: 'STD', column: '商品・製品回転日数（日）', type: 2 },
        { key: 'WIPTR', column: '半製品・仕掛品回転率（回）', type: 1 },
        { key: 'WIPTD', column: '半製品・仕掛品回転日数（日）', type: 2 },
        { key: 'RMSTR', column: '原材料・貯蔵品回転率（回）', type: 1 },
        { key: 'RMSTD', column: '原材料・貯蔵品回転日数（日）', type: 2 },
        { key: 'FATR', column: '固定資産回転率（回）', type: 1 },
        { key: 'FATD', column: '固定資産回転日数（日）', type: 2 },
        { key: 'TFATR', column: '有形固定資産回転率（回）', type: 1 },
        { key: 'TFATD', column: '有形固定資産回転日数（日）', type: 2 },
        { key: 'TATR', column: '総資本回転率（回）', type: 1 },
        { key: 'TATD', column: '総資本回転日数（日）', type: 2 },
        { key: 'LTR', column: '他人資本回転率（回）', type: 1 },
        { key: 'LTD', column: '他人資本回転日数（日）', type: 2 },
        { key: 'APTR', column: '支払債務回転率（回）', type: 1 },
        { key: 'APTD', column: '支払債務回転日数（日）', type: 2 },
        { key: 'IBDTR', column: '有利子負債回転率（回）', type: 1 },
        { key: 'IBDTD', column: '有利子負債回転日数（日）', type: 2 },
        { key: 'ETR', column: '自己資本回転率（回）', type: 1 },
        { key: 'ETD', column: '自己資本回転日数（日）', type: 2 },
        { key: 'GPM', column: '売上高総利益率（％）', type: 1 },
        { key: 'OPM', column: '売上高営業利益率（％）', type: 1 },
        { key: 'RPM', column: '売上高経常利益率（％）', type: 1 },
        { key: 'PTPM', column: '売上高税引前純利益率（％）', type: 1 },
        { key: 'NPM', column: '売上高純利益率（％）', type: 1 },
        { key: 'ORtTAR', column: '総資本経常利益率（％）', type: 1 },
        { key: 'PTPtTAR', column: '総資本税引前純利益率（％）', type: 1 },
        { key: 'NPtTAR', column: '総資本純利益率（％）', type: 1 },
        { key: 'RoE', column: '自己資本純利益率（％）', type: 1 },
        { key: 'OPtOAR', column: '経営資本営業利益率（％）', type: 1 },
        { key: 'CoSR', column: '売上高原価率（％）', type: 2 },
        { key: 'SGAEtSR', column: '売上高管理販売費率（％）', type: 2 },
        { key: 'IBtNSR', column: '売上高利子負担率（％）', type: 2 },
        { key: 'IRoIBD', column: '有利子負債金利（％）', type: 2 },
        { key: 'SGR', column: '売上高増加率（％）', type: 1 },
        { key: 'OPGR', column: '経常利益増加率（％）', type: 1 },
        { key: 'TAGR', column: '総資本増加率（％）', type: 1 },
        { key: 'EGR', column: '自己資本増加率（％）', type: 1 },
        { key: 'MSpE', column: '1人当たり月売上高（千円）', type: 1 },
        { key: 'MOEpE', column: '1人当たり月営業費用（千円）', type: 2 },
        { key: 'MGVApE', column: '1人当たり月粗付加価値（千円）', type: 1 },
        { key: 'MOPpE', column: '1人当たり月経常利益（千円）', type: 1 },
        { key: 'LER', column: '労働装備率（千円）', type: 1 },
    ],
    '建設業': [
        { key: 'NoTC', column: '集計企業数', type: 0 },
        { key: 'ANoE', column: '平均従業員数', type: 0 },
        { key: 'DR', column: '負債比率（％）', type: 2 },
        { key: 'ER', column: '自己資本比率（％）', type: 1 },
        { key: 'CR', column: '流動比率（％）', type: 1 },
        { key: 'QR', column: '当座比率（％）', type: 1 },
        { key: 'FAtER', column: '固定比率（％）', type: 2 },
        { key: 'FAtLTCR', column: '固定長期適合率（％）', type: 2 },
        { key: 'IBDR', column: '有利子負債構成比率（％）', type: 2 },
        { key: 'CIPEtARR', column: '未成工事支出金対受入金（％）', type: 1 },
        { key: 'CATR', column: '流動資産回転率（回）', type: 1 },
        { key: 'CATD', column: '流動資産回転日数（日）', type: 2 },
        { key: 'ARTR', column: '受取債権回転率（回）', type: 1 },
        { key: 'ARTD', column: '受取債権回転日数（日）', type: 2 },
        { key: 'ITR', column: '棚卸資産回転率（回）', type: 1 },
        { key: 'ITD', column: '棚卸資産回転日数（日）', type: 2 },
        { key: 'WIPTR', column: '半製品・仕掛品回転率（回）', type: 1 },
        { key: 'WIPTD', column: '半製品・仕掛品回転日数（日）', type: 2 },
        { key: 'CIPTR', column: '未成工事支出金回転率（回）', type: 1 },
        { key: 'CIPTD', column: '未成工事支出金回転日数（日）', type: 2 },
        { key: 'FATR', column: '固定資産回転率（回）', type: 1 },
        { key: 'FATD', column: '固定資産回転日数（日）', type: 2 },
        { key: 'TFATR', column: '有形固定資産回転率（回）', type: 1 },
        { key: 'TFATD', column: '有形固定資産回転日数（日）', type: 2 },
        { key: 'TATR', column: '総資本回転率（回）', type: 1 },
        { key: 'TATD', column: '総資本回転日数（日）', type: 2 },
        { key: 'LTR', column: '他人資本回転率（回）', type: 1 },
        { key: 'LTD', column: '他人資本回転日数（日）', type: 2 },
        { key: 'APTR', column: '支払債務回転率（回）', type: 1 },
        { key: 'APTD', column: '支払債務回転日数（日）', type: 2 },
        { key: 'IBDTR', column: '有利子負債回転率（回）', type: 1 },
        { key: 'IBDTD', column: '有利子負債回転日数（日）', type: 2 },
        { key: 'CIPRTR', column: '未成工事受入金回転率（回）', type: 1 },
        { key: 'CIPRTD', column: '未成工事受入金回転日数（日）', type: 2 },
        { key: 'ETR', column: '自己資本回転率（回）', type: 1 },
        { key: 'ETD', column: '自己資本回転日数（日）', type: 2 },
        { key: 'GPM', column: '売上高総利益率（％）', type: 1 },
        { key: 'OPM', column: '売上高営業利益率（％）', type: 1 },
        { key: 'RPM', column: '売上高経常利益率（％）', type: 1 },
        { key: 'PTPM', column: '売上高税引前純利益率（％）', type: 1 },
        { key: 'NPM', column: '売上高純利益率（％）', type: 1 },
        { key: 'ORtTAR', column: '総資本経常利益率（％）', type: 1 },
        { key: 'PTPtTAR', column: '総資本税引前純利益率（％）', type: 1 },
        { key: 'NPtTAR', column: '総資本純利益率（％）', type: 1 },
        { key: 'RoE', column: '自己資本純利益率（％）', type: 1 },
        { key: 'OPtOAR', column: '経営資本営業利益率（％）', type: 1 },
        { key: 'CoSR', column: '売上高原価率（％）', type: 2 },
        { key: 'SGAEtSR', column: '売上高管理販売費率（％）', type: 2 },
        { key: 'IBtNSR', column: '売上高利子負担率（％）', type: 2 },
        { key: 'IRoIBD', column: '有利子負債金利（％）', type: 2 },
        { key: 'SGR', column: '売上高増加率（％）', type: 1 },
        { key: 'OPGR', column: '経常利益増加率（％）', type: 1 },
        { key: 'TAGR', column: '総資本増加率（％）', type: 1 },
        { key: 'EGR', column: '自己資本増加率（％）', type: 1 },
        { key: 'MSpE', column: '1人当たり月売上高（千円）', type: 1 },
        { key: 'MOEpE', column: '1人当たり月営業費用（千円）', type: 2 },
        { key: 'MGVApE', column: '1人当たり月粗付加価値（千円）', type: 1 },
        { key: 'MOPpE', column: '1人当たり月経常利益（千円）', type: 1 },
        { key: 'LER', column: '労働装備率（千円）', type: 1 },
    ],
    '販売業・運輸業・サービス業': [
        { key: 'NoTC', column: '集計企業数', type: 0 },
        { key: 'ANoE', column: '平均従業員数', type: 0 },
        { key: 'DR', column: '負債比率（％）', type: 2 },
        { key: 'ER', column: '自己資本比率（％）', type: 1 },
        { key: 'CR', column: '流動比率（％）', type: 1 },
        { key: 'QR', column: '当座比率（％）', type: 1 },
        { key: 'FAtER', column: '固定比率（％）', type: 2 },
        { key: 'FAtLTCR', column: '固定長期適合率（％）', type: 2 },
        { key: 'IBDR', column: '有利子負債構成比率（％）', type: 2 },
        { key: 'ARtAPR', column: '受取債権対支払債務比率（％）', type: 1 },
        { key: 'CATR', column: '流動資産回転率（回）', type: 1 },
        { key: 'CATD', column: '流動資産回転日数（日）', type: 2 },
        { key: 'CDTR', column: '現金・預金回転率（回）', type: 1 },
        { key: 'CDTD', column: '現金・預金回転日数（日）', type: 2 },
        { key: 'ARTR', column: '受取債権回転率（回）', type: 1 },
        { key: 'ARTD', column: '受取債権回転日数（日）', type: 2 },
        { key: 'ITR', column: '棚卸資産回転率（回）', type: 1 },
        { key: 'ITD', column: '棚卸資産回転日数（日）', type: 2 },
        { key: 'FATR', column: '固定資産回転率（回）', type: 1 },
        { key: 'FATD', column: '固定資産回転日数（日）', type: 2 },
        { key: 'TFATR', column: '有形固定資産回転率（回）', type: 1 },
        { key: 'TFATD', column: '有形固定資産回転日数（日）', type: 2 },
        { key: 'OITR', column: '投資（その他）資産回転率（回）', type: 1 },
        { key: 'OITD', column: '投資（その他）資産回転日数（日）', type: 2 },
        { key: 'TATR', column: '総資本回転率（回）', type: 1 },
        { key: 'TATD', column: '総資本回転日数（日）', type: 2 },
        { key: 'LTR', column: '他人資本回転率（回）', type: 1 },
        { key: 'LTD', column: '他人資本回転日数（日）', type: 2 },
        { key: 'APTR', column: '支払債務回転率（回）', type: 1 },
        { key: 'APTD', column: '支払債務回転日数（日）', type: 2 },
        { key: 'IBDTR', column: '有利子負債回転率（回）', type: 1 },
        { key: 'IBDTD', column: '有利子負債回転日数（日）', type: 2 },
        { key: 'STBTR', column: '短期借入金回転率（回）', type: 1 },
        { key: 'STBTD', column: '短期借入金回転日数（日）', type: 2 },
        { key: 'ETR', column: '自己資本回転率（回）', type: 1 },
        { key: 'ETD', column: '自己資本回転日数（日）', type: 2 },
        { key: 'GPM', column: '売上高総利益率（％）', type: 1 },
        { key: 'OPM', column: '売上高営業利益率（％）', type: 1 },
        { key: 'RPM', column: '売上高経常利益率（％）', type: 1 },
        { key: 'PTPM', column: '売上高税引前純利益率（％）', type: 1 },
        { key: 'NPM', column: '売上高純利益率（％）', type: 1 },
        { key: 'ORtTAR', column: '総資本経常利益率（％）', type: 1 },
        { key: 'PTPtTAR', column: '総資本税引前純利益率（％）', type: 1 },
        { key: 'NPtTAR', column: '総資本純利益率（％）', type: 1 },
        { key: 'RoE', column: '自己資本純利益率（％）', type: 1 },
        { key: 'OPtOAR', column: '経営資本営業利益率（％）', type: 1 },
        { key: 'CoSR', column: '売上高原価率（％）', type: 2 },
        { key: 'SGAEtSR', column: '売上高管理販売費率（％）', type: 2 },
        { key: 'IBtNSR', column: '売上高利子負担率（％）', type: 2 },
        { key: 'IRoIBD', column: '有利子負債金利（％）', type: 2 },
        { key: 'SGR', column: '売上高増加率（％）', type: 1 },
        { key: 'OPGR', column: '経常利益増加率（％）', type: 1 },
        { key: 'TAGR', column: '総資本増加率（％）', type: 1 },
        { key: 'EGR', column: '自己資本増加率（％）', type: 1 },
        { key: 'MSpE', column: '1人当たり月売上高（千円）', type: 1 },
        { key: 'MOEpE', column: '1人当たり月営業費用（千円）', type: 2 },
        { key: 'MGVApE', column: '1人当たり月粗付加価値（千円）', type: 1 },
        { key: 'MOPpE', column: '1人当たり月経常利益（千円）', type: 1 },
        { key: 'LER', column: '労働装備率（千円）', type: 1 },
    ]
}

const RadarChartColumn = ["流動比率", "固定比率", "棚卸資産回転日数", "総資本回転日数", "売上高経常利益率", "売上高総利益率", "1人当たり月売上高", "1人当たり月経常利益"]

const FinancialRatioResultMap = {
    'pattern1': [
        { idx: 0, column: '集計企業数', type: 0 },
        { idx: 1, column: '平均従業員数', type: 0 },
        { idx: 2, column: '負債比率（％）', type: 2 },
        { idx: 3, column: '自己資本比率（％）', type: 1 },
        { idx: 4, column: '流動比率（％）', type: 1 },
        { idx: 5, column: '当座比率（％）', type: 1 },
        { idx: 6, column: '固定比率（％）', type: 2 },
        { idx: 7, column: '固定長期適合率（％）', type: 2 },
        { idx: 8, column: '有利子負債構成比率（％）', type: 2 },
        { idx: 9, column: '受取債権対支払債務比率（％）', type: 1 },
        { idx: 10, column: '未成工事支出金対受入金（％）', type: 1 },
        { idx: 11, column: '流動資産回転率（回）', type: 1 },
        { idx: 12, column: '流動資産回転日数（日）', type: 2 },
        { idx: 13, column: '現金・預金回転率（回）', type: 1 },
        { idx: 14, column: '現金・預金回転日数（日）', type: 2 },
        { idx: 15, column: '受取債権回転率（回）', type: 1 },
        { idx: 16, column: '受取債権回転日数（日）', type: 2 },
        { idx: 17, column: '棚卸資産回転率（回）', type: 1 },
        { idx: 18, column: '棚卸資産回転日数（日）', type: 2 },
        { idx: 19, column: '商品・製品回転率（回）', type: 1 },
        { idx: 20, column: '商品・製品回転日数（日）', type: 2 },
        { idx: 21, column: '半製品・仕掛品回転率（回）', type: 1 },
        { idx: 22, column: '半製品・仕掛品回転日数（日）', type: 2 },
        { idx: 23, column: '未成工事支出金回転率（回）', type: 1 },
        { idx: 24, column: '未成工事支出金回転日数（日）', type: 2 },
        { idx: 25, column: '原材料・貯蔵品回転率（回）', type: 1 },
        { idx: 26, column: '原材料・貯蔵品回転日数（日）', type: 2 },
        { idx: 27, column: '固定資産回転率（回））', type: 1 },
        { idx: 28, column: '固定資産回転日数（日）', type: 2 },
        { idx: 29, column: '有形固定資産回転率（回）', type: 1 },
        { idx: 30, column: '有形固定資産回転日数（日）', type: 2 },
        { idx: 31, column: '投資（その他）資産回転率（回）', type: 1 },
        { idx: 32, column: '投資（その他）資産回転日数（日）', type: 2 },
        { idx: 33, column: '総資本回転率（回）', type: 2 },
        { idx: 34, column: '総資本回転日数（日）', type: 1 },
        { idx: 35, column: '他人資本回転率（回）', type: 2 },
        { idx: 36, column: '他人資本回転日数（日）', type: 1 },
        { idx: 37, column: '支払債務回転率（回）', type: 2 },
        { idx: 38, column: '支払債務回転日数（日）', type: 1 },
        { idx: 39, column: '有利子負債回転率（回）', type: 2 },
        { idx: 40, column: '有利子負債回転日数（日）', type: 2 },
        { idx: 39, column: '未成工事受入金回転率（回）', type: 2 },
        { idx: 40, column: '未成工事受入金回転日数（日）', type: 2 },
        { idx: 41, column: '短期借入金回転率（回）', type: 1 },
        { idx: 42, column: '短期借入金回転日数（日）', type: 2 },
        { idx: 43, column: '自己資本回転率（回）', type: 1 },
        { idx: 44, column: '自己資本回転日数（日）', type: 2 },
        { idx: 45, column: '売上高総利益率（％）', type: 1 },
        { idx: 46, column: '売上高営業利益率（％）', type: 1 },
        { idx: 47, column: '売上高経常利益率（％）', type: 1 },
        { idx: 48, column: '売上高税引前純利益率（％）', type: 1 },
        { idx: 49, column: '売上高純利益率（％）', type: 1 },
        { idx: 50, column: '総資本経常利益率（％）', type: 1 },
        { idx: 51, column: '総資本税引前純利益率（％）', type: 1 },
        { idx: 52, column: '総資本純利益率（％）', type: 1 },
        { idx: 53, column: '自己資本純利益率（％）', type: 1 },
        { idx: 54, column: '経営資本営業利益率（％）', type: 1 },
        { idx: 55, column: '売上高原価率（％）', type: 2 },
        { idx: 56, column: '売上高管理販売費率（％）', type: 2 },
        { idx: 57, column: '売上高利子負担率（％）', type: 2 },
        { idx: 58, column: '有利子負債金利（％）', type: 2 },
        { idx: 59, column: '売上高増加率（％）', type: 1 },
        { idx: 60, column: '経常利益増加率（％）', type: 1 },
        { idx: 61, column: '総資本増加率（％）', type: 1 },
        { idx: 62, column: '自己資本増加率（％）', type: 1 },
        { idx: 63, column: '1人当たり月売上高(千円)', type: 1 },
        { idx: 64, column: '1人当たり月営業費用(千円) ', type: 2 },
        { idx: 65, column: '1人当たり月粗付加価値(千円) ', type: 1 },
        { idx: 66, column: '1人当たり月経常利益(千円) ', type: 1 },
        { idx: 67, column: '労働装備率(千円)', type: 1 },
    ]

}

const AutoCalcBSMap = {
    "TCA_CA": ["TCA_CA_CaD", "TCA_CA_AR", "TCA_CA_ARaCWUP", "TCA_CA_S"],
    "TCA_I": ["TCA_I_S", "TCA_I_WIP", "TCA_I_RMS", "TCA_I_CIPE"],
    "TCA_OCA": ["TCA_OCA_AP", "TCA_OCA_PEAI", "TCA_OCA_O"],
    "TCA": ["TCA_CA", "TCA_I", "TCA_OCA", "TCA_AfDA"],
    "TFA_TFA": ["TFA_TFA_BaS", "TFA_TFA_ME", "TFA_TFA_VTE", "TFA_TFA_TES", "TFA_TFA_L", "TFA_TFA_CiP"],
    "TFA_IaOA": ["TFA_IaOA_IS", "TFA_IaOA_O"],
    "TFA": ["TFA_TFA", "TFA_IFA", "TFA_IaOA"],
    "TA": ["TCA", "TFA", "TDA"],
    "TL_TCL": ["TL_TCL_BP", "TL_TCL_APUC", "TL_TCL_STB", "TL_TCL_APaUCP", "TL_TCL_AEaUR", "TL_TCL_BR", "TL_TCL_UCT", "TL_TCL_OCL"],
    "TL_TFL": ["TL_TFL_CB", "TL_TFL_LTD", "TL_TFL_ARB", "TL_TFL_OFL"],
    "TL": ["TL_TCL", "TL_TFL"],
    "TNA_SE": ["TNA_SE_C", "TNA_SE_CS", "TNA_SE_RE", "TNA_SE_TS"],
    "TNA_VaCD": ["TNA_VaCD_UGoOS", "TNA_VaCD_DGaLoH", "TNA_VaCD_LRD"],
    "TNA": ["TNA_SE", "TNA_VaCD", "TNA_SAR"],
    "TLaNA": ["TL", "TNA"]
}

const AutoCalcPLMap = {
    "GP": ["S", "CoS"],
    "OP": ["GP", "SGaAE"],
    "TnOI": ["TnOI_IaDA", "TnOI_OnOI"],
    "TnOE": ["TnOE_IaDA", "TnOE_OnOI"],
    "OrP": ["OP", "TnOI", "TnOE"],
    "PP": ["OrP", "SP", "EL"],
    "NI": ["PP", "APfCT"]
}

const FinancialRatioMapList = [
    { idx: 'NoTC', column: '集計企業数' },
    { idx: 'ANoE', column: '平均従業員数' },
    { idx: 'DR', column: '負債比率（％）' },
    { idx: 'ER', column: '自己資本比率（％）' },
    { idx: 'CR', column: '流動比率（％）' },
    { idx: 'QR', column: '当座比率（％）' },
    { idx: 'FAtER', column: '固定比率（％）' },
    { idx: 'FAtLTCR', column: '固定長期適合率（％）' },
    { idx: 'IBDR', column: '有利子負債構成比率（％）' },
    { idx: 'ARtAPR', column: '受取債権対支払債務比率（％）' },
    { idx: 'CIPEtARR', column: '未成工事支出金対受入金比率（％）' },
    { idx: 'CATR', column: '流動資産回転率（回）' },
    { idx: 'CATD', column: '流動資産回転日数（日）' },
    { idx: 'CDTR', column: '現金・預金回転率（回）' },
    { idx: 'CDTD', column: '現金・預金回転日数（日）' },
    { idx: 'ARTR', column: '受取債権回転率（回）' },
    { idx: 'ARTD', column: '受取債権回転日数（日）' },
    { idx: 'ITR', column: '棚卸資産回転率（回）' },
    { idx: 'ITD', column: '棚卸資産回転日数（日）' },
    { idx: 'STR', column: '商品・製品回転率（回）' },
    { idx: 'STD', column: '商品・製品回転日数（日）' },
    { idx: 'WIPTR', column: '半製品・仕掛品回転率（回）' },
    { idx: 'WIPTD', column: '半製品・仕掛品回転日数（日）' },
    { idx: 'CIPTR', column: '未成工事支出金回転率（回）' },
    { idx: 'CIPTD', column: '未成工事支出金回転日数（日）' },
    { idx: 'RMSTR', column: '原材料・貯蔵品回転率（回）' },
    { idx: 'RMSTD', column: '原材料・貯蔵品回転日数（日）' },
    { idx: 'FATR', column: '固定資産回転率（回）' },
    { idx: 'FATD', column: '固定資産回転日数（日）' },
    { idx: 'TFATR', column: '有形固定資産回転率（回）' },
    { idx: 'TFATD', column: '有形固定資産回転日数（日）' },
    { idx: 'OITR', column: '投資（その他）資産回転率（回）' },
    { idx: 'OITD', column: '投資（その他）資産回転日数（日）' },
    { idx: 'TATR', column: '総資本回転率（回）' },
    { idx: 'TATD', column: '総資本回転日数（日）' },
    { idx: 'LTR', column: '他人資本回転率（回）' },
    { idx: 'LTD', column: '他人資本回転日数（日）' },
    { idx: 'APTR', column: '支払債務回転率（回）' },
    { idx: 'APTD', column: '支払債務回転日数（日）' },
    { idx: 'IBDTR', column: '有利子負債回転率（回）' },
    { idx: 'IBDTD', column: '有利子負債回転日数（日）' },
    { idx: 'CIPRTR', column: '未成工事受入回転率（回）' },
    { idx: 'CIPRTD', column: '未成工事受入回転日数（日）' },
    { idx: 'STBTR', column: '短期借入金回転率（回）' },
    { idx: 'STBTD', column: '短期借入金回転日数（日）' },
    { idx: 'ETR', column: '自己資本回転率（回）' },
    { idx: 'ETD', column: '自己資本回転日数（日）' },
    { idx: 'GPM', column: '売上高総利益率（％）' },
    { idx: 'OPM', column: '売上高営業利益率（％）' },
    { idx: 'RPM', column: '売上高経常利益率（％）' },
    { idx: 'PTPM', column: '売上高税引前利益率（％）' },
    { idx: 'NPM', column: '売上高純利益率（％）' },
    { idx: 'ORtTAR', column: '総資本経常利益率（％）' },
    { idx: 'PTPtTAR', column: '総資本税引前利益率（％）' },
    { idx: 'NPtTAR', column: '総資本純利益率（％）' },
    { idx: 'RoE', column: '自己資本純利益率（％）' },
    { idx: 'OPtOAR', column: '経営資本営業利益率（％）' },
    { idx: 'CoSR', column: '売上高原価率（％）' },
    { idx: 'SGAEtSR', column: '売上高管理販売比率（％）' },
    { idx: 'IBtNSR', column: '売上高利子負担率（％）' },
    { idx: 'IRoIBD', column: '有利子負債金利率（％）' },
    { idx: 'SGR', column: '売上高増加率（％）' },
    { idx: 'OPGR', column: '経営利益増加率（％）' },
    { idx: 'TAGR', column: '総資本増加率（％）' },
    { idx: 'EGR', column: '自己資本増加率（％）' },
    { idx: 'MSpE', column: '一人当り月売上高（千円）' },
    { idx: 'MOEpE', column: '一人当り月営業費用（千円）' },
    { idx: 'MGVApE', column: '一人当り月粗付加価値（千円）' },
    { idx: 'MOPpE', column: '一人当り月経営利益（千円）' },
    { idx: 'LER', column: '労働装備率（千円）' },
]

const SessionDisconnected: string = "I1001"
const SessionTimeOut: string = "I1002"
const SystemError: string = "E9999"
const SessionErrorTitle: string = "セッションエラー"
const SystemErrorTitle: string = "システムエラー"
const SessionDuplicateMsg: string = "同一IDでのログインが行われました。再度ログインして画面操作をお願いします。"
const SessionTimeoutMsg: string = "一定時間操作が行われなかったため、ログアウトしました。"
const SystemErrorMsg: string = "予期せぬエラーが発生しました。"

export {
    BSItems, PLItems, IndustryTypeMap, AnalysisResultMap, RadarChartColumn, FinancialRatioResultMap, AutoCalcBSMap, AutoCalcPLMap, FinancialRatioMapList,
    SessionDisconnected, SessionTimeOut, SystemError, SessionErrorTitle, SystemErrorTitle, SessionDuplicateMsg, SessionTimeoutMsg, SystemErrorMsg
};
